export default "__VITE_ASSET__c02629de__"